import React, {Component} from 'react';


export default class Hashtag extends Component {

    constructor(props) {
        super(props);
        // let firstPart = window.location.host;
        // window.location = firstPart + '/#' + props.idd;

    }

    componentDidMount() {

        let firstPart = window.location.origin;
        let idd = this.props.match.params.idd;

        let newUrl = firstPart + '/#' + idd;
        console.log("selammm", newUrl);
        window.location.href =  newUrl;

    }

    render() {
        return (
            <h2>

            </h2>

        )
    }

}




// WEBPACK FOOTER //
// ./src/components/Hashtag.js